if (!customElements.get('m-mini-collections-slider')) {
  customElements.define(
    'm-mini-collections-slider',
    class MMiniCollectionsSlider extends HTMLElement {
      constructor() {
        super();
        this.isPointerDown = false;
        this.isDragging = false;
        this.startX = 0;
        this.startY = 0;
        this.startScrollLeft = 0;
        this.activePointerId = null;
        this.suppressClick = false;
        this.suppressClickTimer = null;

        this.onPointerDown = (event) => this.handlePointerDown(event);
        this.onPointerMove = (event) => this.handlePointerMove(event);
        this.onPointerUp = (event) => this.handlePointerUp(event);
        this.onClick = (event) => this.handleClick(event);
      }

      connectedCallback() {
        this.slider = this.querySelector('[data-mini-collections-slider]');

        if (!this.slider) return;

        this.slider.addEventListener('pointerdown', this.onPointerDown);
        this.slider.addEventListener('pointermove', this.onPointerMove);
        this.slider.addEventListener('pointerup', this.onPointerUp);
        this.slider.addEventListener('pointercancel', this.onPointerUp);
        this.slider.addEventListener('click', this.onClick, true);

        this.slider.querySelectorAll('a, img').forEach((element) => {
          element.draggable = false;
        });
      }

      disconnectedCallback() {
        if (!this.slider) return;

        this.slider.removeEventListener('pointerdown', this.onPointerDown);
        this.slider.removeEventListener('pointermove', this.onPointerMove);
        this.slider.removeEventListener('pointerup', this.onPointerUp);
        this.slider.removeEventListener('pointercancel', this.onPointerUp);
        this.slider.removeEventListener('click', this.onClick, true);

        window.clearTimeout(this.suppressClickTimer);
      }

      handlePointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;

        this.isPointerDown = true;
        this.isDragging = false;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.startScrollLeft = this.slider.scrollLeft;
        this.activePointerId = event.pointerId;
      }

      handlePointerMove(event) {
        if (!this.isPointerDown) return;

        const distanceX = event.clientX - this.startX;
        const distanceY = event.clientY - this.startY;

        if (!this.isDragging) {
          const isHorizontalDrag = Math.abs(distanceX) > 6 && Math.abs(distanceX) > Math.abs(distanceY);

          if (!isHorizontalDrag) return;

          this.isDragging = true;
          this.slider.classList.add('is-dragging');

          if (this.activePointerId !== null && this.slider.setPointerCapture) {
            this.slider.setPointerCapture(this.activePointerId);
          }
        }

        event.preventDefault();
        this.slider.scrollLeft = this.startScrollLeft - distanceX;
      }

      handlePointerUp(event) {
        if (!this.isPointerDown) return;

        this.isPointerDown = false;
        this.slider.classList.remove('is-dragging');

        if (
          this.activePointerId !== null &&
          this.slider.hasPointerCapture &&
          this.slider.hasPointerCapture(this.activePointerId)
        ) {
          this.slider.releasePointerCapture(this.activePointerId);
        }

        this.activePointerId = null;

        if (this.isDragging) {
          this.suppressNextClick();
        }
      }

      handleClick(event) {
        if (!this.suppressClick) return;

        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
        window.clearTimeout(this.suppressClickTimer);
      }

      suppressNextClick() {
        this.suppressClick = true;
        window.clearTimeout(this.suppressClickTimer);

        this.suppressClickTimer = window.setTimeout(() => {
          this.suppressClick = false;
        }, 350);
      }
    }
  );
}
